import { distanceUnits } from '@shared/config';
import { round } from '@shared/utils/math';
import { Presenter } from '../../presenters/presenter';
import type { Journey } from './journey';

export class JourneyPresenter extends Presenter<Journey> {

    get mode() {
        return this._get('mode', () => {
            switch (this.data.mode) {
                case 'transit':
                    return 'Public Transport';

                case 'walking':
                    return 'Walking';

                case 'bicycling':
                    return 'Bicycling';

                case 'driving':
                default:
                    return 'Driving';
            }
        });
    }

    get modeIcon() {
        return this._get('modeIcon', () => {
            switch (this.data.mode) {
                case 'transit':
                    return 'departure_board';

                case 'walking':
                    return 'directions_walk';

                case 'bicycling':
                    return 'directions_bike';

                case 'driving':
                default:
                    return 'drive_eta';
            }
        });
    }

    get miles() {
        return this._get('miles', () => round((this.data.distance_meters || 0) / 1609.34, 2));
    }

    get distanceFormatted() {
        return this._get('distanceFormatted', () => {
            const meters = this.data.distance_meters || 0;

            if (distanceUnits === 'kilometres') {
                return `${round(meters / 1000, 2)} km`;
            }

            return `${round(meters / 1609.34, 2)} miles`;
        });
    }

    get duration() {
        return this._get('duration', () => this.formatDuration(this.data.duration));
    }

    get durationSeconds() {
        return this._get('durationSeconds', () => this.data.duration);
    }

}
